const TAUROMARKETS_SUPPORT_EMAIL = 'support@tauromarkets.com'
const TAUROMARKETS_MAURITIUS_SUPPORT_EMAIL = 'support@mau.tauromarkets.com'
const PARTNER_EMAIL = 'partners@tauromarkets.com'

export {
  TAUROMARKETS_SUPPORT_EMAIL,
  TAUROMARKETS_MAURITIUS_SUPPORT_EMAIL,
  PARTNER_EMAIL,
}
